import { render, staticRenderFns } from "./ConsiderarEstoqueGrupo.vue?vue&type=template&id=d01835d6&scoped=true"
import script from "./ConsiderarEstoqueGrupo.vue?vue&type=script&lang=js"
export * from "./ConsiderarEstoqueGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01835d6",
  null
  
)

export default component.exports